import { InputAdornment, SvgIcon } from '@mui/material';
import { FC } from 'react';
import { MdCheckCircleOutline as CheckCircleOutlineIcon } from 'react-icons/md';
import CustomTooltip from '../../common/components/CustomTooltip';
import TokenExpired from './TokenInvalid';

interface ITokenVerifiedTextFieldAndorment {
  isConnectorConfigured: boolean;
  isConnectorValid?: boolean;
}

const TokenVerifiedTextFieldAndorment: FC<
  React.PropsWithChildren<ITokenVerifiedTextFieldAndorment>
> = ({ isConnectorConfigured, isConnectorValid = true }) => {
  return (
    <CustomTooltip
      title={
        isConnectorConfigured && isConnectorValid
          ? 'Credentials verified'
          : 'Invalid credentials'
      }>
      <span>
        <InputAdornment position='end'>
          {isConnectorConfigured && isConnectorValid && (
            <SvgIcon
              color='success'
              component={CheckCircleOutlineIcon}
              fontSize='small'
            />
          )}
          {isConnectorConfigured && !isConnectorValid && <TokenExpired />}
        </InputAdornment>
      </span>
    </CustomTooltip>
  );
};

export default TokenVerifiedTextFieldAndorment;
